import * as Sentry from '@sentry/browser'
import { Debug, ExtraErrorData } from '@sentry/integrations'
import { BrowserTracing } from '@sentry/tracing'
import packageJson from '../../package.json'

import { groupIssues, getLogLevelByPriority, shouldDropEvent } from './sentry/index'

/** @param {ErrorEvent} event */
function beforeSend(event, hint) {
  try {
    if (shouldDropEvent(event, hint)) return null

    const fingerprint = groupIssues(event, hint)
    if (fingerprint.length) {
      Object.assign(event, { fingerprint })

      const level = getLogLevelByPriority(fingerprint)
      if (level) {
        Object.assign(event, { level })
      }
    }
  } catch (error) {
    console.warn('Error in beforeSend', error)
  }

  return event
}

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  integrations: [
    new BrowserTracing(),
    new Debug(),
    new ExtraErrorData(),
  ],
  release: `${packageJson.name}-${packageJson.version}`,
  tracesSampleRate: 0.01,
  sendDefaultPii: true, // contain cookie data
  beforeSend,
})

if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'pre') {
  window.Sentry = Sentry
}

export default Sentry
